export const searchParamsKey = "searchParams";
export const msReqData = "msReqData";
export const msUserInfo = "msUserInfo";
export const channelKey = "channelKey";